module.exports = __webpack_public_path__ + "static/media/IMG_0035.10ec8aea.jpg";